<template>
  <div class="container absolute top-10 md:top-[60px] xl:h-auto w-full z-[999] xl:top-[75px] pb-4 overflow-auto">
    <div class="bg-white border-[1px] border-[#8E8E8E] p-4 rounded-[0.625rem] xl:overflow-auto xl:max-h-[900px]">
      <ul ref="listBlock" class="w-full h-full overflow-auto">
        <template v-if="!products.length">
          <span class="text-gray font-medium text-center">
            {{ $t("common.no-results-found") }}
          </span>
        </template>
        <ProductSearchItem v-for="product in products" v-else :key="product.sku" @close-list="$emit('close-list')" :product="product" />
      </ul>
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from "vue"

import ProductSearchItem from "./ProductSearchItem.vue"

defineProps({
  products: {
    type: Array,
    default() {
      return []
    },
  },
})

const emit = defineEmits({
  "scrolled-to-bottom": null,
  "close-list": null,
})

const listBlock = ref(null)

const handleScrollToBottom = (event) => {
  const { scrollHeight, scrollTop, clientHeight } = event.target

  if (Math.abs(scrollHeight - clientHeight - scrollTop) < 1) {
    emit("scrolled-to-bottom")
  }
}

onMounted(() => {
  listBlock.value.addEventListener("scroll", (event) => {
    handleScrollToBottom(event)
  })
})

onBeforeUnmount(() => {
  listBlock.value.removeEventListener("scroll", (event) => {
    handleScrollToBottom(event)
  })
})
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}
</style>
